/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { simulateRaceGet } from '../fn/faxe-eventing-simulator-server/simulate-race-get';
import { SimulateRaceGet$Params } from '../fn/faxe-eventing-simulator-server/simulate-race-get';
import { SimulationProgress } from '../models/simulation-progress';
import { simulationProgressGet } from '../fn/faxe-eventing-simulator-server/simulation-progress-get';
import { SimulationProgressGet$Params } from '../fn/faxe-eventing-simulator-server/simulation-progress-get';
import { SimulationTask } from '../models/simulation-task';
import { SimulationTaskListApiResponse } from '../models/simulation-task-list-api-response';
import { simulationTasksActiveGet } from '../fn/faxe-eventing-simulator-server/simulation-tasks-active-get';
import { SimulationTasksActiveGet$Params } from '../fn/faxe-eventing-simulator-server/simulation-tasks-active-get';
import { simulationTasksAllGet } from '../fn/faxe-eventing-simulator-server/simulation-tasks-all-get';
import { SimulationTasksAllGet$Params } from '../fn/faxe-eventing-simulator-server/simulation-tasks-all-get';
import { simulationTasksFinishedGet } from '../fn/faxe-eventing-simulator-server/simulation-tasks-finished-get';
import { SimulationTasksFinishedGet$Params } from '../fn/faxe-eventing-simulator-server/simulation-tasks-finished-get';
import { simulationTasksGet } from '../fn/faxe-eventing-simulator-server/simulation-tasks-get';
import { SimulationTasksGet$Params } from '../fn/faxe-eventing-simulator-server/simulation-tasks-get';
import { simulationTasksReserveGet } from '../fn/faxe-eventing-simulator-server/simulation-tasks-reserve-get';
import { SimulationTasksReserveGet$Params } from '../fn/faxe-eventing-simulator-server/simulation-tasks-reserve-get';
import { simulationTasksResultPost } from '../fn/faxe-eventing-simulator-server/simulation-tasks-result-post';
import { SimulationTasksResultPost$Params } from '../fn/faxe-eventing-simulator-server/simulation-tasks-result-post';
import { simulationTasksTaskIdTaskGet } from '../fn/faxe-eventing-simulator-server/simulation-tasks-task-id-task-get';
import { SimulationTasksTaskIdTaskGet$Params } from '../fn/faxe-eventing-simulator-server/simulation-tasks-task-id-task-get';

@Injectable({ providedIn: 'root' })
export class FaxeEventingSimulatorServerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `simulateRaceGet()` */
  static readonly SimulateRaceGetPath = '/simulate-race';

  /**
   * Generate simulation tasks for a race
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `simulateRaceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulateRaceGet$Response(params: SimulateRaceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    const obs = simulateRaceGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Generate simulation tasks for a race
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `simulateRaceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulateRaceGet(params: SimulateRaceGet$Params, context?: HttpContext): Observable<any> {
    const resp = this.simulateRaceGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /** Path part for operation `simulationTasksReserveGet()` */
  static readonly SimulationTasksReserveGetPath = '/simulation-tasks/reserve';

  /**
   * Reserve simulation tasks for a client
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `simulationTasksReserveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulationTasksReserveGet$Response(params: SimulationTasksReserveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SimulationTask>>> {
    const obs = simulationTasksReserveGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Reserve simulation tasks for a client
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `simulationTasksReserveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulationTasksReserveGet(params: SimulationTasksReserveGet$Params, context?: HttpContext): Observable<Array<SimulationTask>> {
    const resp = this.simulationTasksReserveGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SimulationTask>>): Array<SimulationTask> => r.body)
    );
  }

  /** Path part for operation `simulationTasksActiveGet()` */
  static readonly SimulationTasksActiveGetPath = '/simulation-tasks/active';

  /**
   * Get all active simulation tasks
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `simulationTasksActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulationTasksActiveGet$Response(params?: SimulationTasksActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SimulationTask>>> {
    const obs = simulationTasksActiveGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all active simulation tasks
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `simulationTasksActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulationTasksActiveGet(params?: SimulationTasksActiveGet$Params, context?: HttpContext): Observable<Array<SimulationTask>> {
    const resp = this.simulationTasksActiveGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SimulationTask>>): Array<SimulationTask> => r.body)
    );
  }

  /** Path part for operation `simulationTasksFinishedGet()` */
  static readonly SimulationTasksFinishedGetPath = '/simulation-tasks/finished';

  /**
   * Get all finished simulation tasks
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `simulationTasksFinishedGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulationTasksFinishedGet$Response(params?: SimulationTasksFinishedGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SimulationTask>>> {
    const obs = simulationTasksFinishedGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all finished simulation tasks
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `simulationTasksFinishedGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulationTasksFinishedGet(params?: SimulationTasksFinishedGet$Params, context?: HttpContext): Observable<Array<SimulationTask>> {
    const resp = this.simulationTasksFinishedGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SimulationTask>>): Array<SimulationTask> => r.body)
    );
  }

  /** Path part for operation `simulationTasksTaskIdTaskGet()` */
  static readonly SimulationTasksTaskIdTaskGetPath = '/simulation-tasks/{taskId}/task';

  /**
   * Get a specific simulation task by ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `simulationTasksTaskIdTaskGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulationTasksTaskIdTaskGet$Response(params: SimulationTasksTaskIdTaskGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SimulationTask>> {
    const obs = simulationTasksTaskIdTaskGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get a specific simulation task by ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `simulationTasksTaskIdTaskGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulationTasksTaskIdTaskGet(params: SimulationTasksTaskIdTaskGet$Params, context?: HttpContext): Observable<SimulationTask> {
    const resp = this.simulationTasksTaskIdTaskGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SimulationTask>): SimulationTask => r.body)
    );
  }

  /** Path part for operation `simulationTasksGet()` */
  static readonly SimulationTasksGetPath = '/simulation-tasks';

  /**
   * Get simulation tasks with paging support. Use ?page=1&pageSize=100 to control paging.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `simulationTasksGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulationTasksGet$Response(params?: SimulationTasksGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SimulationTaskListApiResponse>> {
    const obs = simulationTasksGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get simulation tasks with paging support. Use ?page=1&pageSize=100 to control paging.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `simulationTasksGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulationTasksGet(params?: SimulationTasksGet$Params, context?: HttpContext): Observable<SimulationTaskListApiResponse> {
    const resp = this.simulationTasksGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SimulationTaskListApiResponse>): SimulationTaskListApiResponse => r.body)
    );
  }

  /** Path part for operation `simulationTasksAllGet()` */
  static readonly SimulationTasksAllGetPath = '/simulation-tasks/all';

  /**
   * Get ALL simulation tasks without paging (use with caution for large datasets)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `simulationTasksAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulationTasksAllGet$Response(params?: SimulationTasksAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SimulationTask>>> {
    const obs = simulationTasksAllGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get ALL simulation tasks without paging (use with caution for large datasets)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `simulationTasksAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulationTasksAllGet(params?: SimulationTasksAllGet$Params, context?: HttpContext): Observable<Array<SimulationTask>> {
    const resp = this.simulationTasksAllGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SimulationTask>>): Array<SimulationTask> => r.body)
    );
  }

  /** Path part for operation `simulationProgressGet()` */
  static readonly SimulationProgressGetPath = '/simulation-progress';

  /**
   * Get simulation progress
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `simulationProgressGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulationProgressGet$Response(params: SimulationProgressGet$Params, context?: HttpContext): Observable<StrictHttpResponse<SimulationProgress>> {
    const obs = simulationProgressGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get simulation progress
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `simulationProgressGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  simulationProgressGet(params: SimulationProgressGet$Params, context?: HttpContext): Observable<SimulationProgress> {
    const resp = this.simulationProgressGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SimulationProgress>): SimulationProgress => r.body)
    );
  }

  /** Path part for operation `simulationTasksResultPost()` */
  static readonly SimulationTasksResultPostPath = '/simulation-tasks/result';

  /**
   * Mark a simulation task as completed
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `simulationTasksResultPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  simulationTasksResultPost$Response(params: SimulationTasksResultPost$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = simulationTasksResultPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Mark a simulation task as completed
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `simulationTasksResultPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  simulationTasksResultPost(params: SimulationTasksResultPost$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.simulationTasksResultPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
